import React from 'react'
import { ContentfulMediaTextBlock } from './modules/contentfulMediaTextBlock';
import { ContentfulPageContentCard } from './modules/contentfulPageContentCard';

export const PageContentSection = ({ sectionVisibility, sections }) => {
    if(sectionVisibility) {
        return (
            <div className='relative block'>
                {sections.map((item, index) => {
                    switch (item.__typename) {
                        case 'ContentfulMediaTextBlock':
                            return <ContentfulMediaTextBlock key={index} index={index} item={item}/>;
                        // case 'ContentfulPageContentCard':
                        //     return <ContentfulPageContentCard key={index} index={index} item={item} />
                        default:
                        return null; // Return null for unknown types
                    }
                })}
            </div>
        )
    } else return null

}